import EFVideo from '@/components/UI/EFVideo';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';

let textSceneG: any = null,
    controller = null;
export default function G() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [isH5, setIsH5] = useState(false);
    const { locale } = useRouter();

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (textSceneG) {
                    AniContainer.removeScene(textSceneG);
                    textSceneG = null;
                }

                controller = new ScrollMagic.Controller();
                const sceneScale = new ScrollMagic.Scene({
                    triggerElement: '.dpu-detail-G',
                    triggerHook: 1,
                    offset: window?.innerHeight * 2.5,
                    duration: window?.innerHeight,
                });

                const terminal = window?.innerWidth >= 1440 ? 1 : window?.innerWidth > 1024 ? 2 : window?.innerWidth >= 768 ? 3 : 4;
                if (window?.innerWidth > 1024) {
                    const tweenScale = TweenMax.fromTo(
                        '.dpu-detail-G .video-box',
                        0.5,
                        {
                            width: '100%',
                            height: '100%',
                        },
                        {
                            width:
                                terminal === 1
                                    ? '1200px'
                                    : terminal === 2
                                        ? 'calc(100vw - 444px)'
                                        : terminal === 3
                                            ? 'calc(100vw - 256px)'
                                            : 'calc(100vw - 48px)',
                            height: terminal === 1 ? 600 : terminal === 2 ? 499 : 270,
                        },
                    );
                    sceneScale.setTween(tweenScale);
                    controller.addScene(sceneScale);
                }

                textSceneG = AniContainer.create({
                    asyncFromTo: [
                        ...(isEU
                            ? []
                            : [
                                ['.dpu-detail-G .box0 .title', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.2],
                                ['.dpu-detail-G .box0 .tip', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.2],
                                ['.dpu-detail-G .box0 .title', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 0.5],
                                ['.dpu-detail-G .box0 .tip', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 0.6],
                                ['.dpu-detail-G .video-box .video1', { opacity: 1 }, { opacity: 0 }, 0.25],
                                ['.dpu-detail-G .video-box .video2', { opacity: 0 }, { opacity: 1 }, 0.25],
                            ]),
                        ['.dpu-detail-G .box1 .title', { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0.5],
                        ['.dpu-detail-G .box1 .title', { opacity: 1, y: 0 }, { opacity: 0, y: -60 }, 0.1],
                        ['.dpu-detail-G .video-box .mask', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.dpu-detail-G .box2-layer-h5', { opacity: 0 }, { opacity: 0.2 }, 0.1],
                        ['.dpu-detail-G .box2 .subtitle', { opacity: 0, y: 60 }, { opacity: 1, y: 0 }, 0.5],
                        ['.dpu-detail-G .box2 .title', { opacity: 0, y: 70 }, { opacity: 1, y: 0 }, 0.5],
                        ['.dpu-detail-G .box2 .desc', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.5],
                        ['.dpu-detail-G .box2 .tips', { opacity: 0, y: 90 }, { opacity: 1, y: 0 }, 0.5],
                        ['.dpu-detail-G .box2', { opacity: 1 }, { opacity: 1 }, 0.5],
                    ],
                    // asyncTimeLine: [0.2, 0.3, 0.5, 0.5, 1, 1, 1.25, 2, 3, 0.1, 3, 3.25, 3.5, 3.75],
                    asyncTimeLine: isEU ? [1.25, 2, 3, 0.1, 3, 3.25, 3.5, 3.75] : [0.2, 0.3, 0.5, 0.5, 1, 1, 1.25, 2, 3, 0.1, 3, 3.25, 3.5, 3.65, 3.75],
                    triggerElement: '.dpu-detail-G',
                    triggerHook: 0,
                    offset: 0,
                    duration: isEU ? '100%' : '300%',
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (textSceneG) {
                    AniContainer.removeScene(textSceneG);
                    textSceneG = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [isH5]);

    return (
        <section className={`dpu-detail-G dpu-detail-section ${css['dpu-detail-G']}`}>
            <div className="sticky-box">
                <div className={`video-box ${isH5 ? 'g-h5' : 'g-pc'}`}>
                    {!isEU && !isH5 && (
                        <EFVideo
                            // ref={videoRef1PC}
                            // sources={['https://websiteoss.ecoflow.com/upload/video/1742960796240/G.mp4']}
                            sources={['/responsive/video/delta-pro-ultra/launch/G0.mp4']}
                            className="video1 video pc"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secF_title')}
                        />
                    )}
                    {!isH5 && (
                        <EFVideo
                            // ref={videoRef2PC}
                            sources={['/responsive/video/delta-pro-ultra/launch/7.mp4']}
                            className="video2 video pc"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secG_sec1_title')}
                        />
                    )}
                    {isH5 && (
                        <EFVideo
                            // ref={videoRef1H5}
                            // sources={['https://websiteoss.ecoflow.com/upload/video/1742960796240/G.mp4']}
                            sources={['/responsive/video/delta-pro-ultra/launch/G0.mp4']}
                            className="video1 video h5"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secF_title')}
                        />
                    )}
                    {isH5 && (
                        <EFVideo
                            // ref={videoRef2H5}
                            sources={['/responsive/video/delta-pro-ultra/launch/7_h5.mp4']}
                            className="video2 video h5"
                            muted
                            autoPlay={true}
                            loop={true}
                            preload="auto"
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('secG_sec1_title')}
                        />
                    )}
                    <div className="mask"></div>
                </div>
                <div className="box0 box">
                    <div className="box-in">
                        <h2 className="title">{t('secF_title')}</h2>
                        <p className="tip">{t('secF_tip')}</p>
                    </div>
                </div>
                <div className="box1 box">
                    <div className="box-in">
                        <h2 className="title">{t('secG_sec1_title')}</h2>
                    </div>
                </div>
                <div className="box2-layer-h5"></div>
                <div className="box2 box">
                    <div className="box-in">
                        <h4 className="subtitle">{t('secG_sec2_subtitle')}</h4>
                        <h2 className="title">{t('secG_sec2_title')}</h2>
                        <p className="desc">
                            {t.rich('secG_sec2_desc', {
                                sup: (text: any) => <sup className="sup">{text}</sup>,
                            })}
                        </p>
                        <div className='tips'>
                            <div className='tips-item1 tips-item'>
                                <span className='svg'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="29" viewBox="0 0 18 29" fill="none">
                                        <path d="M4.20052 5.86686C2.98567 5.86686 2.00028 6.85129 2 8.06608V24.0661C2 25.2811 2.98549 26.2666 4.20052 26.2666H13.7995C15.0145 26.2666 16 25.2811 16 24.0661V8.06608C15.9997 6.85129 15.0143 5.86686 13.7995 5.86686H4.20052ZM11.3997 1.99967H6.60026C6.04798 1.99967 5.60026 1.55196 5.60026 0.999674C5.60044 0.447538 6.04808 -0.000326157 6.60026 -0.000326157H11.3997C11.9519 -0.000326157 12.3996 0.447538 12.3997 0.999674C12.3997 1.55196 11.952 1.99967 11.3997 1.99967ZM13.7995 3.86686C16.1189 3.86686 17.9997 5.74673 18 8.06608V24.0661C18 26.3857 16.1191 28.2666 13.7995 28.2666H4.20052C1.88092 28.2666 0 26.3857 0 24.0661V8.06608C0.000281042 5.74672 1.8811 3.86686 4.20052 3.86686H13.7995Z" fill="white" />
                                    </svg>
                                </span>
                                {t('secG_sec2_tips1')}
                            </div>
                            <div className='tips-item2 tips-item'>
                                <span className='svg'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                        <path d="M27 6.63021C27 5.72991 26.2701 5 25.3698 5H21.1497V27H25.3698C26.2701 27 27 26.2701 27 25.3698V6.63021ZM13.1367 27H19.1497V5H13.1367V27ZM5 25.3698C5 26.2701 5.72991 27 6.63021 27H11.1367V5H6.63021C5.72991 5 5 5.72991 5 6.63021V25.3698ZM29 25.3698C29 27.3747 27.3747 29 25.3698 29H6.63021C4.62534 29 3 27.3747 3 25.3698V6.63021C3 4.62534 4.62534 3 6.63021 3H25.3698C27.3747 3 29 4.62534 29 6.63021V25.3698Z" fill="white" />
                                    </svg>

                                </span>
                                {t('secG_sec2_tips2')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
